var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTwitterCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 300,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.8,231.3c0.1,3,0.2,6,0.2,9c0,91.2-69.4,196.4-196.5,196.4c-39,0-75.3-11.4-105.8-31 c5.4,0.6,10.9,1,16.5,1c32.4,0,62.1-11,85.8-29.6c-30.2-0.6-55.7-20.5-64.5-48c4.2,0.8,8.5,1.2,13,1.2c6.3,0,12.4-0.8,18.2-2.4 c-31.6-6.3-55.4-34.2-55.4-67.7c0-0.3,0-0.6,0-0.9c9.3,5.2,20,8.3,31.3,8.6c-18.5-12.4-30.7-33.5-30.7-57.5 c0-12.7,3.4-24.5,9.3-34.7c34,41.8,84.9,69.3,142.3,72.2c-1.2-5.1-1.8-10.3-1.8-15.7c0-38.1,30.9-69,69-69 c19.9,0,37.8,8.4,50.4,21.8c15.7-3.1,30.5-8.8,43.9-16.8c-5.2,16.1-16.1,29.7-30.4,38.2c14-1.7,27.3-5.4,39.7-10.9 C459.1,209.5,447.3,221.6,433.8,231.3z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTwitterCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-twitter-circle.c9a2cfe3.svg";
export { ForwardRef as ReactComponent };